import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: "maintenance",
    loadChildren: () => import('./components/maintenance-page/maintenance-page.module').then(m => m.MaintenancePageModule)
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "start",
        loadChildren: () => import('./components/start-page/start-page.module').then(m => m.StartPageModule)
      },
      {
        path: "survey",
        loadChildren: () => import('./components/survey-page/survey-page.module').then(m => m.SurveyPageModule)
      },
      {
        path: "ending",
        loadChildren: () => import('./components/end-page/end-page.module').then(m => m.EndPageModule)
      },
      {
        path: "ending/:params",
        loadChildren: () => import('./components/end-page/end-page.module').then(m => m.EndPageModule)
      },
      {
        path: "linkedin-auth",
        loadChildren: () => import('./components/linked-in-page/linked-in-page.module').then(m => m.LinkedInPageModule)
      },
      {
        path: "linkedin-auth/:params",
        loadChildren: () => import('./components/linked-in-page/linked-in-page.module').then(m => m.LinkedInPageModule)
      },
      {
        path: "mbd-google",
        loadChildren: () => import('./components/mbd-google-page/mbd-google-page.module').then(m => m.MBDGooglePageModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
